module.exports = __webpack_public_path__ + "img/fd71c844fcaf82c9bc69f862db9e04f8.gif";